"use strict";var t=require("react"),e=require("./IntlContext-DcFt0tgW.js");function r(){const r=t.useContext(e.IntlContext);if(!r)throw new Error(void 0);return r}exports.useIntlContext=r,exports.useLocale=function(){return r().locale};
